
import Security from "../../../assets/outline/Security.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SecurityIcon({ className, dataTestid = "SecurityIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Security data-testid={dataTestid} className={classes} {...rest} />
  );
}
